export class PurchaseFile {
    public itens: PurchaseFileItem[];
    public file: string;
    public products: number[];
    public grupoId?: number;

        constructor(itens: PurchaseFileItem[], file: string, products: number[], grupoId?: number) {
        this.itens = itens;
        this.file = file;
        this.products = products;
        this.grupoId = grupoId;
    }
}

export class PurchaseFileItem {

    constructor(
        public cpf: string,
        public telefone: number,
        public value: NumberConstructor
    ) { }
}

export class PurchaseBatch {
    public batchId: number;
    public purchaseId: number;
}